"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const qs_1 = require("qs");
const activePopover_1 = require("./activePopover"), activePopoverSelector = activePopover_1;
const audience_1 = require("./audience"), audienceSelector = audience_1;
const error_1 = require("./error"), errorSelector = error_1;
const form_1 = require("./form"), formSelector = form_1;
const home_1 = require("./home"), homeSelector = home_1;
const notification_1 = require("./notification"), notificationSelector = notification_1;
const notificationDelivery_1 = require("./notificationDelivery"), notificationDeliverySelector = notificationDelivery_1;
const overview_1 = require("./overview"), overviewSelector = overview_1;
const phonePreview_1 = require("./phonePreview"), phonePreviewSelector = phonePreview_1;
const reportGraphType_1 = require("./reportGraphType"), reportGraphTypeSelector = reportGraphType_1;
const wizardModal_1 = require("./wizardModal"), wizardModalSelector = wizardModal_1;
const index_1 = require("../index");
exports.default = redux_1.combineReducers({
    activePopover: activePopover_1.default,
    audience: audience_1.default,
    error: error_1.default,
    form: form_1.default,
    home: home_1.default,
    notification: notification_1.default,
    notificationDelivery: notificationDelivery_1.default,
    overview: overview_1.default,
    phonePreview: phonePreview_1.default,
    reportGraphType: reportGraphType_1.default,
    wizardModal: wizardModal_1.default,
});
exports.getAudience = (state) => audienceSelector.getAudience(state.audience);
exports.getTotalAudienceSize = (state) => audienceSelector.getTotalAudienceSize(state.audience);
exports.getIsCreatingCampaign = (state) => homeSelector.getIsCreatingCampaign(state.home);
exports.getIsFetching = (state) => homeSelector.getIsFetching(state.home);
exports.getIsNewCampaignPopoverOpen = (state) => homeSelector.getIsNewCampaignPopoverOpen(state.home);
exports.getIsNewCampaignPopoverClosing = (state) => homeSelector.getIsNewCampaignPopoverClosing(state.home);
exports.getIsCampaignTypeSelectorOpen = (state) => homeSelector.getIsCampaignTypeSelectorOpen(state.home);
exports.getIsCampaignTypeSelectorClosing = (state) => homeSelector.getIsCampaignTypeSelectorClosing(state.home);
exports.getIsNotificationDeliveryModalOpen = (state) => notificationDeliverySelector.getIsNotificationDeliveryModalOpen(state.notificationDelivery);
exports.getLastViewPage = (state) => notificationDeliverySelector.getLastViewPage(state.notificationDelivery);
exports.getIsTapBehaviorDeepLink = (state) => notificationDeliverySelector.getIsTapBehaviorDeepLink(state.notificationDelivery);
exports.getAlertOptionHoverValue = (state) => notificationSelector.getAlertOptionHoverValue(state.notification);
exports.getIsAlertOptionsOpen = (state) => notificationSelector.getIsAlertOptionsOpen(state.notification);
exports.getIsOverviewModalOpen = (state) => overviewSelector.getIsOverviewModalOpen(state.overview);
exports.getIsArchiveModalOpen = (state) => overviewSelector.getIsArchiveModalOpen(state.overview);
exports.getIsSendTestModalOpen = (state) => overviewSelector.getIsSendTestModalOpen(state.overview);
exports.getTriggeredAnimation = (state) => overviewSelector.getTriggeredAnimation(state.overview);
exports.getIsTapBehaviorSelectorOpen = (state) => notificationSelector.getIsTapBehaviorSelectorOpen(state.notification);
exports.getIsError = (state) => errorSelector.getIsError(state.error);
exports.getIsPopoverModalFormOpen = (state) => activePopoverSelector.getIsPopoverModalFormOpen(state.activePopover);
exports.getActivePopover = (state) => activePopoverSelector.getActivePopover(state.activePopover);
exports.getCurrentFormPage = (state) => formSelector.getCurrentPage(state.form);
exports.getShouldShowPhonePreview = (state) => {
    if (window.location.pathname.includes('settings')) {
        const tapBehavior = index_1.getEditableCampaignDeliverableTapBehavior(state);
        const currentWizard = exports.getCurrentWizard(state.app);
        switch (currentWizard) {
            case 'messageAndMedia':
            case 'alertOptions':
                return true;
            case 'tapBehavior':
            case '':
                return tapBehavior.type === 'PRESENT_EXPERIENCE';
            default:
                return false;
        }
    }
    if (window.location.pathname.includes('report')) {
        const tapBehavior = index_1.getCampaignTapBehavior(state, qs_1.parse(window.location.search.substring(1)).campaignId);
        return tapBehavior.type === 'PRESENT_EXPERIENCE';
    }
    return formSelector.getShouldShowPhonePreview(state.app.form, index_1.getEditableCampaign(state));
};
exports.getSegmentSize = (state) => formSelector.getSegmentSize(state.form);
exports.getIsAudienceSizeUpdating = (state) => formSelector.getIsAudienceSizeUpdating(state.form);
exports.getIsDeviceListUploading = (state) => formSelector.getIsDeviceListUploading(state.form);
exports.getIsSegmentSizeUpdating = (state) => formSelector.getIsSegmentSizeUpdating(state.form);
exports.getIsPhonePreviewActive = (state, preview) => phonePreviewSelector.getIsPhonePreviewActive(state.phonePreview, preview);
exports.getIsPhonePreviewClosing = (state) => phonePreviewSelector.getIsPhonePreviewClosing(state.phonePreview);
exports.getReportGraphType = (state) => reportGraphTypeSelector.getReportGraphType(state);
exports.getCurrentWizard = (state) => wizardModalSelector.getCurrentWizard(state.wizardModal);
exports.getIsWizardModalOpen = (state) => wizardModalSelector.getIsWizardModalOpen(state.wizardModal);
exports.getIsWizardModalClosing = (state) => wizardModalSelector.getIsWizardModalClosing(state.wizardModal);
